import React, { useState } from 'react';
import { Close } from '@mui/icons-material';
import {
  ButtonBase,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import toast from 'react-hot-toast';

import appColors from '../app_colors';
import appStrings from '../app_strings';
import { BackrsForm } from './BackrsForm/BackrsForm';
import { sendPasswordReset } from '../atoms/Login/login.util';

const environmentUrl = import.meta.env.VITE_API_BASEURL || '';
const LOGIN_STRINGS = appStrings.login.unified;

const defaultForgotPasswordValues = {
  forgotPasswordEmail: '',
};

const forgotPasswordStyle = {
  color: appColors.text.navy,
  fontSize: '0.8125rem',
  fontWeight: 700,
};

const forgotPasswordConstainerStyle = {
  display: 'block',
  ml: 'auto',
  mr: 1,
};

export const ForgotPassword = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const fields = [
    {
      id: 'forgotPasswordEmail',
      name: 'forgotPasswordEmail',
      placeholder: 'Email',
      type: 'text',
      autoComplete: 'email',
      autoFocus: true,
      rules: {
        required: LOGIN_STRINGS.error.emailRequired,
        pattern: { value: /^\S+@\S+$/i, message: LOGIN_STRINGS.error.invalidEmail },
      },
    },
  ];

  const handleSubmission = async (data) => {
    try {
      await sendPasswordReset(data.forgotPasswordEmail, environmentUrl);

      toast.success('A password reset link was sent to your email.');
    } catch {
      console.log('Error sending password reset email');
    } finally {
      closeModal();
    }
  };

  return (
    <>
      <ButtonBase sx={forgotPasswordConstainerStyle} onClick={openModal} disableRipple>
        <Typography sx={forgotPasswordStyle}>{LOGIN_STRINGS.forgotPassword}</Typography>
      </ButtonBase>
      <Dialog
        PaperProps={{
          style: { borderRadius: 8 },
        }}
        open={isOpen}
        onClose={closeModal}
      >
        <DialogTitle mt={2}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Please enter your email address and we will send you a link to reset your password.
          </Typography>
          <BackrsForm
            fields={fields}
            defaultValues={defaultForgotPasswordValues}
            buttonLabel="Send"
            onSubmit={handleSubmission}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
